export const scrollToWizardProgress = (progressSteps: HTMLElement | null) => {
  if (!progressSteps) {
    return;
  }

  const scrollTop = window.scrollY + progressSteps.getBoundingClientRect().top - 16;

  window.scrollTo({ top: scrollTop, behavior: 'smooth' });
};
